import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container footer-inner">
      <div>© {new Date().getFullYear()} PolyLink Site</div>
      {/* <div className="footer-links">
        <a href="https://tacc.ust.hk/#overview" target="_blank" rel="noreferrer">About</a>
        <a href="https://tacc.ust.hk/#overview" target="_blank" rel="noreferrer">Terms</a>
        <a href="https://tacc.ust.hk/#overview" target="_blank" rel="noreferrer">Contact</a>
      </div> */}
    </div>
  </footer>
);

export default Footer;
